import { render } from "./creditsList.vue?vue&type=template&id=349098a0&scoped=true&ts=true"
import script from "./creditsList.vue?vue&type=script&lang=ts"
export * from "./creditsList.vue?vue&type=script&lang=ts"

import "./creditsList.vue?vue&type=style&index=0&id=349098a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-349098a0"]])

export default __exports__